import { SvgIcon, useTheme } from '@mui/material'

import { Alerts } from 'features/alerts/components/Alerts'
import { AlertData } from 'features/alerts/components/Alerts/types'
import { Alert } from 'features/alerts/types/alert'
import { DomainBidderAlert } from 'features/globalSetup/api/types/domainBidderAlert'
import { DomainBidder } from 'features/globalSetup/types/domainBidder'
import UnpluggedIcon from 'images/icons/unplugged.svg?react'

type Props = {
  alerts: DomainBidder['alerts']
}

export const DomainBidderAlerts = ({ alerts }: Props): JSX.Element => {
  const theme = useTheme()

  const switcher = (alert: Alert<DomainBidderAlert>): AlertData | undefined => {
    switch (alert.name) {
      case 'csEnabled':
        return {
          color: theme.palette.warning.main,
          Icon: (
            <SvgIcon
              component={UnpluggedIcon}
              inheritViewBox
            />
          ),
          tooltip: { text: alert.description },
        }

      case 's2sEnabled':
        return {
          color: theme.palette.warning.main,
          Icon: (
            <SvgIcon
              component={UnpluggedIcon}
              inheritViewBox
            />
          ),
          tooltip: { text: alert.description },
        }

      default:
        throw Error('Missing alert config')
    }
  }

  return <Alerts<DomainBidderAlert> {...{ alerts, switcher }} />
}
